export const memberProfile = {
  "verified": "Zweryfikowany",
  "online": "Połączony",
  "memberSince": "Członek od",
  "contact": "Kontakt",
  "share": "Udostępnij",
  "respondsIn": "Odpowiada w",
  "responseRate": "wskaźnik odpowiedzi",
  "exchangesCompleted": "Zrealizowane wymiany",
  "reviews": "opinii",
  "responseRateLabel": "Wskaźnik odpowiedzi",
  "memberSinceLabel": "Członek od",
  "years": "lat",
  "year": "rok",
  "exchangeHistory": "Historia wymian",
  "property": "Dom",
  "reviewsTab": "Opinie",
  "all": "Wszystkie",
  "completed": "Zakończone",
  "upcoming": "Nadchodzące",
  "cancelled": "Anulowane",
  "exchangeWith": "Wymiana z",
  "nights": "nocy",
  "noExchangeInCategory": "Brak wymian w tej kategorii",
  "offeredProperty": "Proponowany dom",
  "memberReviews": "Opinie członków"
};
